import cls from './DatePickerComp.module.scss';
import React, { useRef } from 'react';
import DatePicker from 'react-datepicker';
import { Calendar } from '../../../assets/images/icons';
import UnfocusableWrapper from '../UnfocusableWrapper/UnfocusableWrapper';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons';
export const DatePickerComp = props => {
	const { toggleDP = () => { }, value, selectedDate, dateChangeHandler, inputContainerClassName, inputClassName, inputStyle, iconClassName, placeholder, id, hasCalendarIcon, ...rest } = props;
	const dateTimePickerRef = useRef();

	const toggleDatePicker = () => {
		if (dateTimePickerRef?.current?.state?.isOpen) {
			dateTimePickerRef?.current?.togglePicker(false);
		}
	};
	const onChangeDate = date => {
		dateChangeHandler?.(date);
	};
	return (
		<>
			<UnfocusableWrapper onClickOutside={toggleDatePicker}>
				<DatePicker
					yearDropdownItemNumber={50}
					onCalendarOpen={() => toggleDP(true)}
					onCalendarClose={() => toggleDP(false)}
					showYearDropdown
					dateFormatCalendar="MMMM"
					scrollableYearDropdown
					placeholderText=""
					customInput={
						<div className={classNames(cls.inputContainer, inputContainerClassName)} style={{ minWidth: '240px', padding: '7px 0'}}>
							<input readOnly value={value} type="text" id={id ?? 'date-picker'} className={classNames(cls.inputField, inputClassName)} style={inputStyle} placeholder={placeholder} />
							{hasCalendarIcon && <FontAwesomeIcon icon={faCalendarDays} style={{ width: '14px', height: '14px', paddingRight: '10px' }} />}
						</div>
					}
					selected={selectedDate ?? new Date()}
					onChange={onChangeDate}
					{...rest}
				/>
			</UnfocusableWrapper>
		</>
	);
};
